import { Pill } from "PFComponents/pill";
import { useTranslation } from "react-i18next";

import { RemoveHandler, ValueBadgeGenericContentProps } from "./value_badge";

type ValueBadgeGenericProps = ValueBadgeGenericContentProps & {
  onRemove: RemoveHandler;
};

export const ValueBadgeGeneric = ({
  displayValue,
  value,
  onRemove,
  locked,
  tabIndex
}: ValueBadgeGenericProps) => {
  const { t } = useTranslation("core", {
    keyPrefix: "components.selectV2"
  });

  return (
    <Pill
      small
      text={displayValue}
      {...(!locked
        ? {
            deleteTitle: t("removeOption", {
              label: displayValue
            }),
            onDelete: (e) => onRemove(value, e),
            onDeleteKeyDown: (e) => e.stopPropagation(),
            tabIndex
          }
        : {})}
    />
  );
};
